module.exports = __webpack_public_path__ + "img/qr.2e38c1cf.svg";